export default __webpack_public_path__ + "static/media/icon-shield.b0c7129c.svg";